/**
 * Checks if the given string ends with a forward slash and removes it if it does.
 */
export const stripTrailingSlash = (string: string) => (
    string.endsWith('/') ? string.slice(0, -1) : string
);
